
//RECAPTCHA_KEY
export const CLIENT_RECAPTCHA_KEY = "AIzaSyBNpkKH2avyfUclgt3i8020WCFbRBG5lHc";
export const SATYA_RECAPTCHA_KEY = "6LeEjZUqAAAAAF9XlwYZ_fJnQ4rumrML1szdUdJ6";
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY || SATYA_RECAPTCHA_KEY;

//SALESFORCE

export const integrationConfig = {
    development:{
        endPoint:"https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DDx0000002DFb",
        orgId:"00DDx0000002DFb",
        mediaShareURL:"https://www.test.bestbuyads.com/"
    },
    stage:{
        endPoint:"https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DO500000Z4ZJD",
        orgId:"00DO500000Z4ZJD",
        mediaShareURL:"https://www.stage.bestbuyads.com/"
    },
    production:{
        endPoint:"https://login.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DHu000003NfV2",
        orgId:"00DHu000003NfV2",
        mediaShareURL:"https://www.bestbuyads.com/"
    }
}
